import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["credits", "hasLowCredits"],
  _excluded2 = ["hasLowCredits", "totalUsage", "usageLimit"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { LayoutBox } from 'breeze-intelligence-kit';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Text = styled(LayoutBox).withConfig({
  displayName: "CreditsDisplay__Text",
  componentId: "sc-1y6ztyz-0"
})(["font-weight:600;"]);
export const CreditsDisplay = _ref => {
  let {
      credits,
      hasLowCredits
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const color = hasLowCredits ? 'danger' : 'base';
  return /*#__PURE__*/_jsx(Text, Object.assign({}, rest, {
    as: "span",
    color: color,
    display: "inline-block",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentCredits.available",
      options: {
        count: credits
      }
    })
  }));
};
export const CreditsDisplaySubscription = _ref2 => {
  let {
      hasLowCredits,
      totalUsage,
      usageLimit
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const color = hasLowCredits ? 'danger' : 'base';
  const Usage = () => /*#__PURE__*/_jsx(Text, Object.assign({}, rest, {
    as: "span",
    color: color,
    display: "inline-block",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentCredits.used",
      options: {
        totalUsage,
        usageLimit
      }
    })
  }));
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "enrichmentCredits.subscriptionCredits",
    options: {
      usage: /*#__PURE__*/_jsx(Usage, {})
    }
  });
};